import { render, staticRenderFns } from "./CardProdutosEmAberto.vue?vue&type=template&id=ca61c70e&"
import script from "./CardProdutosEmAberto.vue?vue&type=script&lang=js&"
export * from "./CardProdutosEmAberto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports